import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './styles/LoginPage.css';
import logo from "./assets/logo.png";

export default function LoginPage() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [activeTab, setActiveTab] = useState('login');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(username, password);
      navigate('/finance/');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    }
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="fullscreen-wrapper">
      {/* Animated water drops background */}
      <div className="water-drops">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="drop"></div>
        ))}
      </div>

      <div className="login-container">
        <div className="login-card">
          <div className="brand-section">
            <div className="brand-logo-wrapper">
              <img src={logo} alt="Arosia Water Logo" className="brand-logo-img" />
            </div>
            <h1 className="brand-title">Arosia Water</h1>
            <p className="brand-subtitle">TEAM</p>
          </div>

          

          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your username"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
                <button 
                  type="button" 
                  className="password-toggle"
                  onClick={togglePassword}
                >
                  {showPassword ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            {error && <p className="error-msg">{error}</p>}

            <button type="submit" className="login-btn">Login</button>
          </form>

          <div className="extra-links">
            <a href="#forgot-password">Forgot password?</a>
          </div>
        </div>
      </div>
    </div>
  );
}